import {
  BasicIconButton,
  BrandIconSpinner,
  Button,
  Input,
  Modal,
} from 'components';
import React, { useCallback, useState } from 'react';
import { AddMorelist, SubmitContainer } from './Profile.style';
import { t } from 'i18next';
import TextEditor from 'components/TextEditor';
import { ReactComponent as EditFilled } from 'assert/images/Profile/edit.svg';
import { ReactComponent as AddCircle } from 'assert/images/Profile/addCircle.svg';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import UploadImagePreview from 'components/UploadImagePreview';
import {
  InsertAddmore,
  deleteAddmore,
  getaddMoreByuserId,
  updateAddmoreList,
} from 'redux/features/AddMoreSectionSlice';
import { Notification } from 'components/CustomNotification';
import { useDispatch, useSelector } from 'react-redux';
import { AddMoreStyle } from './AddProfile.style';
import { useLocation } from 'react-router-dom';
import { hasTextInside, swipeModalWidth } from 'utils/helper';
import useWindowDimensions from 'components/Dimention';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';

export default function AddMoreSection({ addMoreList }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const getUsername = location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim();

  const [loading, setLoading] = useState(false);
  const [addMoreID, setAddMoreID] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [deleteAttachment, setDeleteAttachment] = useState(null);
  const [textLength, setTextLength] = useState(0);
  const [openDeleteModel, setOpenDeleteModel] = useState(null);
  const [tempDeleteAttachment, setTempDeleteAttachment] = useState(null);
  const [states, setState] = useState({
    title: '',
    description: '',
    image: [],
  });
  const [errMsg, setErrMsg] = useState({
    title: '',
    description: '',
  });

  const handleChange = useCallback((data, name) => {
    setState((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  }, []);

  const handleValidation = useCallback(() => {
    const validationParams = { ...errMsg };
    if (!states.title?.trim()) validationParams.title = 'Title is required';
    else validationParams.title = '';

    if (!states.description || !hasTextInside(states.description))
      validationParams.description = 'Description is required';
    else if (textLength > 1500) validationParams.description = 'Max limit 1500';
    else validationParams.description = '';
    setErrMsg(validationParams);
  }, [errMsg, states, textLength]);

  const resetFields = () => {
    setState({
      title: '',
      description: '',
      image: [],
    });
    setErrMsg({
      title: '',
      description: '',
    });
    setOpenModal(false);
    setLoading(false);
  };

  const handleSubmit = () => {
    handleValidation();
    const validation = states.title?.trim() && states.description && hasTextInside(states.description) && textLength <= 1500;
    if (validation) {
      setLoading(true);
      const formData = new FormData();
      formData.set('title', states.title);
      formData.set('details', states.description);
      formData.set('createdById', getProfile?.userId);
      // typeof states?.image?.[0] !== 'string' &&
      formData.append('attachment', states.image[0] || []);
      (deleteAttachment || (typeof states.image?.[0] !== 'string' && tempDeleteAttachment)) &&
        formData.append('image', JSON.stringify([deleteAttachment || tempDeleteAttachment]));
      dispatch(
        addMoreID
          ? updateAddmoreList(formData, addMoreID)
          : InsertAddmore(formData)
      )
        .then(() => {
          dispatch(getaddMoreByuserId());
          resetFields();
          Notification(
            'success',
            addMoreID ? 'Updated Successfully' : 'Added Successfully'
          );
        })
        .catch((err) => {
          resetFields();
          Notification('warning', err.response?.data?.message);
        });
    }
  };

  const onDeleteExperience = () => {
    setLoading(true);
    dispatch(deleteAddmore(openDeleteModel))
      .then(() => {
        dispatch(getaddMoreByuserId());
        resetFields();
        setOpenDeleteModel(null);
        Notification('success', 'Deleted Successfully');
      })
      .catch((err) => {
        resetFields();
        setOpenDeleteModel(null);
        Notification('warning', err.response?.data?.message);
      });
  };

  const editExperience = (data) => {
    states.title = data.title;
    states.description = data.details;
    states.image = data.attachment ? [data.attachment] : [];
    setTempDeleteAttachment(data.attachment || null)
    setAddMoreID(data.id);
    setState((prevState) => ({
      ...prevState,
    }));
    setOpenModal(true);
  };

  const handleGetContent = () => {
    return <AddMoreStyle>
      <BrandIconSpinner loading={loading} />
      <Input
        type={'text'}
        label={t('profile.Title')}
        onChange={(data) => handleChange(data, 'title')}
        value={states.title}
        errMsg={errMsg.title}
        required
      />
      <UploadImagePreview
        isReplace
        isDelete
        maxFiles={1}
        types="imageupload"
        label={t('profile.Image')}
        handleFileSRC={(data) => handleChange(data, 'image')}
        value={states.image}
        onCloseFiles={(data) => {
          data?.startsWith('https://') && setDeleteAttachment(data);
          setState((prev) => ({
            ...prev,
            image: [],
          }));
        }}
      />
      <TextEditor
        label={t('profile.Details')}
        required
        onChange={(data) => handleChange(data, 'description')}
        value={states.description}
        errMsg={errMsg.description}
        maxLength={1500}
        callbackTextLength={setTextLength}
      />
      <SubmitContainer className="modal-footer addmore-btn">
        <Button
          label={t('HomePage.Save')}
          onClick={handleSubmit}
          type="text"
        />
        <Button
          label={t('profile.Close')}
          onClick={resetFields}
          type="text"
        />
      </SubmitContainer>
    </AddMoreStyle>
  }

  return (
    <div>
      <AddMorelist>
        {addMoreList && (
          <>
            {addMoreList?.map((data) => {
              return (
                <div className="addmore-list-container" key={data.title}>
                  <div className="card-header">
                    <div className="card-title">{data.title}</div>
                    {getProfile.username === decodeURIComponent(currentUsername) && <div className="header-icons">
                      <div className="edit-icon">
                        <BasicIconButton
                          icon={<EditFilled />}
                          ariaLabel={'edit-icon'}
                          onClick={() => editExperience(data)}
                          size="small"
                        />
                      </div>
                      <div className="remove-icon">
                        <BasicIconButton
                          icon={<Delete />}
                          ariaLabel={'remove-icon'}
                          onClick={() => setOpenDeleteModel({ id: data?.id, image: [data?.attachment] })}
                          size="small"
                        />
                      </div>
                    </div>}
                  </div>
                  {data?.attachment && (
                    <div className="addmore-list-image">
                      <img src={data.attachment} />
                    </div>
                  )}
                  <div
                    className="rich-editor-description"
                    dangerouslySetInnerHTML={{
                      __html: data.details,
                    }}
                  />
                </div>
              );
            })}
          </>
        )}
        {getProfile.username === decodeURIComponent(currentUsername) &&
          <div className="add-more-section-btn">
            <Button
              type="text"
              label={t('profile.AddMoreSection')}
              onClick={() => setOpenModal(true)}
              startIcon={<AddCircle />}
            />
          </div>}
      </AddMorelist>
      <Modal
        removeHeader
        modalchanges="headerProfile"
        handleCancelModal={() => setOpenDeleteModel(null)}
        openModal={openDeleteModel !== null}
        content={
          <div className="confirmModal">
            <div className="title">
              Are you sure you want to delete the <br />
              {
                addMoreList.find((item) => item.id === openDeleteModel)
                  ?.title
              }{' '}
              section ?
            </div>
            <div>
              <Button
                label="Cancel"
                variant="text"
                onClick={() => setOpenDeleteModel(null)}
              />
              <Button label="Yes" color="error" onClick={onDeleteExperience} />
            </div>
          </div>
        }
      />
      {isSmallScreen ?
        <SwipeableEdgeDrawer
          title={t('profile.AddMoreSection')}
          openDrawer={openModal}
          handleCloseDrawer={resetFields}
        >
          {handleGetContent()}
        </SwipeableEdgeDrawer>
        :
        <Modal
          content={
            handleGetContent()
          }
          modalchanges={'commonModal'}
          modelTitle={t('profile.AddMoreSection')}
          openModal={openModal}
          handleCancelModal={resetFields}
        />
      }

    </div>
  );
}
